import React, { useEffect, useState } from 'react'
import { countryService } from '../../../../services'
import { Col, Row, Tag } from 'antd'
import CardSkeleton from '../../../../utils/skeleton';
import { ROLE, ROLES } from '../../../../constants';

const boxStyle = {
    backgroundColor: "#FFFFFF",
    border: "1px solid #ccc",
    borderRadius: 8,
    width: "100%",
};

const fieldStyle = {
    display: "flex",
    alignItems: "start",
    justifyContent: "flex-start",
    width: "45%",
    color: "#606A72"
};

const fieldStyle2 = {
    display: "flex",
    alignItems: "center",
    width: "70%",
    color: "#606A72"
};

const fieldStyleValue = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "55%",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    whiteSpace: "normal",
}

const fieldStyleValue2 = {
    display: "flex",
    alignItems: "center",
    width: "60%",
}
function Content({ data, loading, customer }) {
    const role = localStorage.getItem("role")

    const [countries, setCountries] = useState([]);

    const customerInformation = [
        {
            title: "Customer Information",
            content: [
                {
                    label: "Customer Name",
                    value: customer?.name || "-"
                },
                {
                    label: "Email",
                    value: customer?.email || "-"
                },
                {
                    label: "Phone",
                    value: customer?.phone || "-"
                },
                {
                    label: "City",
                    value: customer?.city || "-"
                },
                {
                    label: "Country",
                    value: countries.find((item) => {
                        const isoCodes = item?.iso_code?.split(/\s*\/\s*/);
                        const customerCodes = customer?.country?.split(/\s*\/\s*/);

                        return isoCodes?.some(code => customerCodes?.includes(code));
                    })?.name || "-"
                },
            ]
        },
    ];

    const vehicleDetails = [
        {
            title: "Vehicle Details",
            content: [
                {
                    label: "Vehicle",
                    value: data?.vehicle || "-"
                },
                {
                    label: "Model/Product",
                    value: data?.product || "-"
                },
                {
                    label: "Year",
                    value: data?.year || "-"
                },
                {
                    label: "Vehicle Type",
                    value: data?.vehicle_type || "-"
                },
                {
                    label: "Engine Type",
                    value: data?.engine_type || "-"
                },
                {
                    label: "Chasis No",
                    value: data?.chasis_no || "-"
                }
            ],
        },
    ];

    const titleStatus = [
        {
            title: "Title & Status",
            content: [
                {
                    label: "Title Number",
                    value: data?.title_number || "-"
                },
                {
                    label: "Title State",
                    value: data?.title_state || "-"
                },
                {
                    label: "Title Owner",
                    value: data?.title_owner || "-"
                },
                {
                    label: "Title Available",
                    value: data?.title || "-"
                },
                {
                    label: "Car Status",
                    value: (
                        <Tag
                            color={
                                data?.car_status === "LOADED"
                                    ? "green"
                                    : data?.car_status === "AT YARD"
                                        ? "gold"
                                        : data?.car_status === "LOAD PLAN"
                                            ? "blue"
                                            : data?.car_status === "RETURNED"
                                                ? "red" :
                                                "default"
                            }
                        >
                            {data?.car_status || "-"}
                        </Tag>
                    )

                },
                {
                    label: "Release Status",
                    value: data?.release_status || "-"
                }
            ]
        },
    ];

    const logisticsShipping = [
        {
            title: "Logistics & Shipping",
            content: [
                {
                    label: "Operating Port",
                    value: data?.operating_port || "-"
                },
                {
                    label: "Destination",
                    value: data?.destination || "-"
                },
                {
                    label: "Shipping Class",
                    value: data?.shipping_class_id || "-"
                },
                {
                    label: "Container Size",
                    value: data?.container_size || "-"
                },
                {
                    label: "Container No",
                    value: data?.container_no || "-"
                },
                {
                    label: "Tracking No",
                    value: data?.tracking_no || "-"
                },
                {
                    label: "Cutting Car",
                    value: data?.cutting_car || "-"
                },
                {
                    label: "Booking No",
                    value: data?.booking_no || "-"
                },
                {
                    label: "BOL",
                    value: data?.bol || "-"
                },
                {
                    label: "Storage",
                    value: data?.storage || "-"
                },
                {
                    label: "Transportation",
                    value: data?.transportation || "-"
                },
                {
                    label: "Date Receiving",
                    value: data?.date_rcd || "-"
                },
                {
                    label: "Arrival Date",
                    value: data?.arrival_date || "-"
                }
            ]
        },
    ];

    const financialInfo = [
        {
            title: "Financial Information",
            content: [
                {
                    label: "Price",
                    value: data?.price || "-"
                },
                {
                    label: "Value",
                    value: data?.values || "-"
                },
                // {
                //     label: "Invoice Amount",
                //     value: data?.invoice_amount || "-"
                // },
                {
                    label: "Invoice Number",
                    value: data?.invoice_no || "-"
                },
                // {
                //     label: "Freight Charges($)",
                //     value: data?.freight_charges || "-"
                // },
                {
                    label: "Towing Charges($)",
                    value: <span>${data?.towing_charges || "-"}</span>
                },
                {
                    label: "Yard Charges($)",
                    value: data?.yard_charges || "-"
                },
                {
                    label: "Loading Charges($)",
                    value: data?.loading_charges || "-"
                },
                {
                    label: "Buying Charges($)",
                    value: data?.buying_charges || "-"
                },
                {
                    label: "Selling Charges($)",
                    value: data?.selling_charges || "-"
                },
                // {
                //     label: "Labour",
                //     value: data?.labour || "-"
                // },
                // {
                //     label: "Material",
                //     value: data?.material || "-"
                // },
                {
                    label: "Quotation Id",
                    value: data?.quotation_id || "-"
                }
            ]
        },
    ];

    const additionalDetail = [
        {
            title: "Additional Details",
            content: [
                {
                    label: "Lot No",
                    value: data?.['lot_#'] || "-"
                },
                {
                    label: "Keys Available",
                    value: data?.keys || "-"
                },

                {
                    label: "BOS",
                    value: data?.BOS || "-"
                },
                {
                    label: "Weight",
                    value: data?.weight || "-"
                },
                {
                    label: "Towing Location",
                    value: data?.towing_location || "-"
                },
                {
                    label: "Date Received",
                    value: data?.date_rcd || "-"
                },
                {
                    label: "File Reference",
                    value: data?.file_ref || "-"
                },

                {
                    label: "Free Days",
                    value: data?.free_days || "-"
                },
                {
                    label: "Days Left",
                    value: data?.days_left || "-"
                },
                {
                    label: "Chassis",
                    value: data?.chassis || "-"
                },
                {
                    label: "Per Day Charges($)",
                    value: data?.per_day_charges || "-"
                },
                {
                    label: "Storage Charges($)",
                    value: data?.storage_charges || "-"
                },

                {
                    label: "Carrier Name",
                    value: data?.carrier_name || "-"
                },
            ]
        }
    ];

    const getCountries = async () => {
        const response = await countryService.countryGet()
        if (response?.success) {
            setCountries(response.data)
        }
    }

    useEffect(() => {
        getCountries()
    }, [])

    const Section = ({ section }) => {
        const isSpecial =
            section.title === "Logistics & Shipping" ||
            section.title === "Financial Information";

        return (

            <div>
                <div className="text-sm border-b-2 border-[#EDEDED] p-2 flex justify-between ">

                    <div className='flex gap-2 items-center'>

                        <p className='p-0 m-0 font-semibold'> {section.title}</p>

                        {section.title === "Customer Information" && (
                            data?.is_globex_vehicle === 1 && (
                                <Tag color="#3dabce" style={{ fontSize: 8 }}>
                                    GLOBEX
                                </Tag>
                            )
                        )}
                    </div>

                    {section.title === "Financial Information" && (
                        data?.invoice_no ? (
                            <a
                                href={`/invoice/view/${data?.invoice_no}`}
                                className="text-[10px] p-0 m-0 text-primary hover:text-primary"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View Invoices
                            </a>
                        ) : (
                            <span className="text-[10px] p-0 m-0 text-gray-400">
                                View Invoices
                            </span>
                        )
                    )
                    }
                </div>

                {section.content.map((item, index) => {
                    const isLast = index === section.content.length - 1;
                    return (
                        <div className={`flex gap-0 ${isLast ? '' : 'border-b border-[#EDEDED]'} text-xs pb-2 m-2 w-[calc(100%-24px)]`}
                            key={index}
                        >
                            {isSpecial ? (
                                <>
                                    <div style={fieldStyle2} >{item.label}</div>
                                    <div style={fieldStyleValue2}>{item.value}</div>
                                </>
                            ) : (
                                <>
                                    <div style={fieldStyle}>{item.label}</div>
                                    <div style={fieldStyleValue} >{item.value}</div>
                                </>
                            )}
                        </div>
                    )
                })
                }
            </div >)
    }

    return (
        <Row gutter={16}>
            {/* RIGHT SIDE (Second Row but shown beside) */}
            <Col span={12}>
                {role !== ROLES.CUSTOMER &&
                    <div style={boxStyle}>
                        {loading ?
                            <div className='p-3'>
                                <CardSkeleton />
                            </div>
                            :
                            <div>

                                {customerInformation.map((section, index) => (
                                    <Section key={index} section={section} />
                                ))}
                            </div>
                        }
                    </div>
                }

                <div style={{ ...boxStyle, marginTop: role !== ROLES.CUSTOMER ? 16 : 0 }}>
                    {loading ?
                        <div className='p-3'>
                            <CardSkeleton />
                        </div>

                        :
                        <div>
                            {vehicleDetails.map((section, index) => (
                                <Section key={index} section={section} />
                            ))
                            }
                        </div>
                    }
                </div>

                <div style={{ ...boxStyle, marginTop: 16 }}>
                    {loading ?
                        <div className='p-3'>
                            <CardSkeleton />
                        </div>
                        :
                        <div>
                            {titleStatus.map((section, index) => (
                                <Section key={index} section={section} />
                            ))}
                        </div>
                    }
                </div>

                <div style={{ ...boxStyle, marginTop: 16 }}>
                    {loading ?
                        <div className='p-3'>
                            <CardSkeleton />
                        </div>
                        :
                        <div>
                            {additionalDetail.map((section, index) => (
                                <Section key={index} section={section} />
                            ))}
                        </div>
                    }
                </div>

            </Col>
            <Col span={12}>
                <div style={boxStyle}>
                    {loading ?
                        <div className='p-3'>
                            <CardSkeleton />
                        </div>
                        :
                        <div>
                            {logisticsShipping.map((section, index) => (
                                <Section key={index} section={section} />
                            ))
                            }
                        </div>
                    }
                </div>

                <div style={{ ...boxStyle, marginTop: 16 }}>
                    {loading ?
                        <div className='p-3'>
                            <CardSkeleton />
                        </div>
                        :
                        <div>
                            {financialInfo.map((section, index) => (
                                <Section key={index} section={section} />
                            ))}
                        </div>
                    }
                </div>
            </Col>
        </Row>
    )
}

export default Content
